import React, { Component } from 'react';
import { renderHTMLContent } from '../../common/function';

class TableSort extends Component {
  render() {
    const { sortOptions, onSortChange, onReset } = this.props;

    return (
      <div className='d-flex mt-1 align-items-center mb-1'>
        <h5 className='m-0 font-weight-bold'>Sort By :</h5>
        <select
          name='table_data_select'
          id='table_data_select'
          onChange={(e) => onSortChange(e.target.value)}
          className='h-min-content ml-35px w-lg-30 w-sm-50'
        >
          <option selected='selected' disabled='disabled' value='DEFAULT'>
            Select...
          </option>
          {sortOptions && sortOptions.length
            ? sortOptions.map((value, index) => (
                <option key={index} value={index}>
                  {renderHTMLContent(value, 'span')}
                </option>
              ))
            : null}
        </select>

        <span className='up tooltip-hover-questions ml-1'>
          <div className='tootip_box'> Reset </div>
          <button
            type='submit'
            aria-label='Reset'
            className='btn btn-circle btn-refresh pointer_class'
            id='Tooltip-2'
            onClick={onReset}
          >
            <i className='fa fa-refresh p-0' aria-hidden='true' />
          </button>
        </span>
      </div>
    );
  }
}

export default TableSort;



// WEBPACK FOOTER //
// ./src/Components-2025/IR/TableSort.jsx